/**
 * 상세 화면 개편 — 처방 요약·목록 표 styled(페이지 로컬).
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import styled from "styled-components";
import { COLOR_SYSTEM } from "components/design/design-system";

export const SummaryBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  border-radius: 12px;
`;

export const SummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  align-items: center;
`;

export const SummaryItem = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
`;

export const SummaryKey = styled.span`
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  margin-right: 4px;
`;

export const WarningLine = styled.div`
  font-size: 13px;
  color: ${COLOR_SYSTEM.get("Red")?.[600]};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;

export const Th = styled.th`
  text-align: left;
  padding: 6px 8px;
  border-bottom: 1px solid ${COLOR_SYSTEM.get("Gray")?.[100]};
  color: ${COLOR_SYSTEM.get("Gray")?.[500]};
  font-weight: 600;
  white-space: nowrap;
`;

export const Tr = styled.tr<{ $problem?: boolean }>`
  cursor: pointer;
  background-color: ${(p) => (p.$problem ? COLOR_SYSTEM.get("Red")?.[50] : "transparent")};
  &:hover {
    background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
  }
`;

export const Td = styled.td`
  padding: 6px 8px;
  border-bottom: 1px solid ${COLOR_SYSTEM.get("Gray")?.[50]};
  color: ${COLOR_SYSTEM.get("Gray")?.[800]};
  vertical-align: middle;
`;

export const DrugName = styled.span`
  font-weight: 600;
`;

export const LayoutButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
